import api from "../api";

const propertyProposalService = {
  // Get property proposal create form data
  getCreateData: async (propertyId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/create`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching property proposal create data:", error);
      throw error;
    }
  },

  // Create property proposal
  create: async (propertyId, data) => {
    try {
      const response = await api.post(
        `/properties/${propertyId}/reports/property_proposals`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error creating property proposal:", error);
      throw error;
    }
  },

  // Get property proposal for editing
  getForEdit: async (propertyId, reportId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/${reportId}/edit`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching property proposal for edit:", error);
      throw error;
    }
  },

  // Update property proposal
  update: async (propertyId, reportId, data) => {
    try {
      const response = await api.put(
        `/properties/${propertyId}/reports/property_proposals/${reportId}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error updating property proposal:", error);
      throw error;
    }
  },

  // Delete property proposal
  delete: async (propertyId, reportId) => {
    try {
      const response = await api.delete(
        `/properties/${propertyId}/reports/property_proposals/${reportId}/destroy`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting property proposal:", error);
      throw error;
    }
  },

  // Get property proposal
  get: async (propertyId, reportId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/${reportId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching property proposal:", error);
      throw error;
    }
  },

  // Get property proposal for editing (alias for get)
  getPropertyProposal: async (propertyId, proposalId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/${proposalId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching property proposal:", error);
      throw error;
    }
  },

  // Update property proposal (alias for update)
  updatePropertyProposal: async (propertyId, proposalId, data) => {
    try {
      const response = await api.put(
        `/properties/${propertyId}/reports/property_proposals/${proposalId}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error updating property proposal:", error);
      throw error;
    }
  },

  // Delete property proposal (alias for delete)
  deletePropertyProposal: async (propertyId, reportId) => {
    try {
      const response = await api.delete(
        `/properties/${propertyId}/reports/property_proposals/${reportId}/destroy`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting property proposal:", error);
      throw error;
    }
  },

  // Remove image from property proposal
  removeImage: async (propertyId, reportId, field) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/${reportId}/${field}`
      );
      return response.data;
    } catch (error) {
      console.error("Error removing image:", error);
      throw error;
    }
  },

  // Get property proposal sign page
  getSignPage: async (propertyId, reportId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/${reportId}/sign`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching sign page:", error);
      throw error;
    }
  },

  // Sign property proposal
  sign: async (propertyId, reportId, data) => {
    try {
      const response = await api.post(
        `/properties/${propertyId}/reports/property_proposals/${reportId}/sign`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error signing property proposal:", error);
      throw error;
    }
  },

  // Display property proposal
  display: async (propertyId, reportId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/${reportId}/display`
      );
      return response.data;
    } catch (error) {
      console.error("Error displaying property proposal:", error);
      throw error;
    }
  },

  // Get signed property proposal
  getSigned: async (propertyId, reportId) => {
    try {
      const response = await api.get(
        `/properties/${propertyId}/reports/property_proposals/signed/${reportId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching signed property proposal:", error);
      throw error;
    }
  },
};

export default propertyProposalService;
